import Button from '@/components/Button'
import EmptyBlock from '@/components/EmptyBlock'
import Layout, { Stack } from '@/components/Layout'
import LottieImage from '@/components/LottieImage'
import Text from '@/components/Text'
import { useRouter } from 'next/router'
import * as styles from './style'

const NoBookmarksFound = (): JSX.Element => {
  const router = useRouter()

  const handleScheduleRoute = (): void => {
    router.push(`/schedule/browse`)
  }
  return (
    <EmptyBlock>
      <Layout>
        <Stack y alignItems="center" justifyContent="space-between">
          <div className={`${styles.iconAnimationContainer} mb-sm`}>
            <LottieImage
              autoplay
              className={styles.iconAnimation}
              name="notes-animation"
              path={'https://ddq2bomue87t4.cloudfront.net/dialog-icons/notes.json'}
            />
          </div>
          <Text weight="lg" className="mb-xxxs" size="md" tag="h4" responsiveSize={{ sm: 'md', md: 'lg' }}>
            You don't have any bookmarks yet
          </Text>
          <Text tag="p" size="xs" weight="sm">
            Any classes or articles you bookmark can be found here.
          </Text>
          <Button label="Browse Classes" theme="primary" size="md" onClick={handleScheduleRoute} className="mt-md" />
        </Stack>
      </Layout>
    </EmptyBlock>
  )
}

export default NoBookmarksFound
